module.exports = __webpack_public_path__ + "img/kyIcon_2.a696e20b.png";